<template>
  <div>
    <div class="transaction row" v-if="parsedTxInfo && parsedTxInfo.length">
      <div v-if="!$md.mobile() || $md.tablet()">
        <table class="transaction-list">
          <thead>
            <tr>
              <th class="text-left" style="width: 32%">{{ $t('transaction.TX_DATE') }} / {{ $t('transaction.NAME') }}</th>
              <th class="text-right" style="width: 24%">{{ $t('transaction.AREA_APPROX') }}</th>
              <th class="text-center" style="width: 7%"></th>
              <th class="text-right" style="width: 13%">{{ $t('transaction.FT_PRICE') }}</th>
              <th class="text-right" style="width: 14%">{{ $t('transaction.CONSIDERATION') }}</th>
              <th class="text-center" style="width: 10%"></th>
            </tr>
          </thead>
          <tbody>
            <transaction-list-item
              v-for="(record, index) in formatedDesktopTransaction"
              :key="index"
              :transaction="record"
              :buildingPage="true"
              :stockSearchButton="true"
            ></transaction-list-item>
          </tbody>
        </table>
      </div>
      <div class="tx-card-container" v-if="$md.mobile() && !$md.tablet()">
        <tx-card
          v-for="(record, index) in txInfo"
          :key="index"
          class="tx-record-card"
          :tx="record"
          :icsType="ics"
          :buildingPage="true"
          :stockSearchButton="true"
        ></tx-card>      
      </div>
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-offset-3 col-xs-6
                      col-sm-offset-4 col-sm-4 
                      col-md-offset-5 col-md-2">
            <more-button
              :name="$t('transaction.MORE_TX')"
              :backgroundColor="'#FFFFFF'"
              :borderColor="'#000000'"
              :textColor="'#000000'"
              :url="txURL"
              class="more-btn">
            </more-button>
          </div>
        </div>
      </div>
    </div>
    <div class="no-tx" v-show="noTx">{{ $t('transaction.NO_TX_MSG') }}</div>
  </div>
</template>
<script>
// import moment from 'moment';
import gql from 'graphql-tag';
import timeUtils from '@/mixins/timeUtils';
import numberFormat from '@/mixins/numberFormat';
import MoreButton from '@/components/RoundButton';
import TransactionListItem from '@/components/Transaction/ListItem';
import TxCard from '@/components/Transaction/MobileTransactionRecordCard';

export default {
  props: ['buildingName', 'pisBuildingId', 'streetId', 'txType', 'ics', 'themeColor'],
  mixins: [timeUtils, numberFormat],
  data() {
    return {
      maxDisplayRow: 5,
      txC: null,
      txI: null,
      txS: null,
      outputTxICS: null,
      lang: window.lang,
      extraInfo: {},
    };
  },
  components: {
    MoreButton,
    TransactionListItem,
    TxCard,
  },
  computed: {
    noTx() {
      if (this.pisBuildingId) {
        if (this.ics === 'i' && 
          Array.isArray(this.txI) && 
          this.txI.length === 0) {
          return true;
        }

        if (this.ics === 'c' && 
          Array.isArray(this.txC) && 
          this.txC.length === 0) {
          return true;
        }

        if (this.ics === 's' && 
          Array.isArray(this.txS) && 
          this.txS.length === 0) {
          return true;
        }
      }
      return false;
    },
    txURL() {
      let sbu = '';
      switch (this.outputTxICS) {
        case 'i':
          sbu = 'industrial';
          break;
        case 's':
          sbu = 'shops';
          break;
        default:
          sbu = 'office'
      }
      let type = '';
      switch (this.txType) {
        case 'S':
          type = '/sold';
          break;
        case 'L':
          type = '/leased';
          break;
      }

      return `${window.SITE_URL}transaction/${sbu}${type}?keywords={
        "suggestionWord":"${this.buildingName}",
        "type":"building",
        "value":"${this.pisBuildingId}",
        "ics":"${this.outputTxICS}"}`;
    },
    txInfo() {
      let displayTx = [];
      if (this.ics === 'c') {
        this.outputTxICS = 'c';
        displayTx = this.txC;
      } else if (this.ics === 'i') {
        this.outputTxICS = 'i';
        displayTx = this.txI;
      } else if (this.ics === 's') {
        this.outputTxICS = 's';
        displayTx = this.txS;
      }

      if (Array.isArray(displayTx)) {
        let output = [];
        output = displayTx.map(tx => ({
          ...tx,
          chi_name: tx.name_zh,
          eng_name: tx.name_en,
          dist_name_zh: tx.district.name_zh,
          dist_name_en: tx.district.name_en,
          floor_zh: tx.floor ? this.floorFormat(tx.floor, 'zh-HK') : '',
          floor_en: tx.floor ? this.floorFormat(tx.floor, 'english') : '',
          txDate: this.str2time(tx.tx_date),
          area: this.totalArea(tx.areas),
          sell: tx.sell_total,
          ft_sell: tx.sell_feet,
          rent: tx.rent_total,
          ft_rent: tx.rent_feet,
          pis_bldg_id: this.pisBuildingId,
        }),
        );
        if (this.ics === 's') {
          output = output.map(tx => ({
            ...tx,
            area1: tx.areas[0].amount,
            area_desc1: tx.areas[0].name_zh,
            area2: tx.areas[1].amount,
            area_desc2: tx.areas[1].name_zh,
            area3: tx.areas[2].amount,
            area_desc3: tx.areas[2].name_zh,
            area4: tx.areas[3].amount,
            area_desc4: tx.areas[3].name_zh,
            street_id: this.streetId,
          }),
          );
        }
        return output.slice(0, this.maxDisplayRow);
      }
      return [];
    },
    parsedTxInfo() {
      if (Array.isArray(this.txInfo)) {
        let output = [];
        output = this.txInfo.map(tx => ({
          ...tx,
          txDate: this.str2time(tx.tx_date),
          displayArea: tx.areas[0] ? this.fmt(tx.areas[0].amount) : '',
          displayPriceTotal: tx.tx_type === 'S' ? this.numberFormat(tx.sell_total) : this.fmt(tx.rent_total, 0, 3, ','),
          displayPriceFeet: tx.tx_type === 'S' ? `$${this.fmt(tx.sell_feet, 0, 3, ',')}` : `$${this.fmt(tx.rent_feet, 0, 3, ',')}`,
          displaySource: tx.upload_source === 'Land Register' ? this.$t('transaction.LAND_REGISTER') : this.$t('transaction.MARKET_INFO'),
          displayFloor: this.floorFormat(tx.floor),
          displayFlat: this.flatFormat(tx),
        }),
        );

        return output.slice(0, this.maxDisplayRow);
      }
      return [];
    },
    formatedDesktopTransaction() {
      return this.formatTx(this.txInfo);
    },
  },
  methods: {
    totalArea(areas) {
      let area = 0;
      for (let i = 0; i < areas.length; i += 1) {
        area += areas[i].amount;
      }
      return area;
    },
    newFloorFormat(f, lang) {
      if (f === '**HIGH**') {
        if (lang === 'english') { return 'High Floor'; }
        return '高層';
      }
      if (f === '**MID**') {
        if (lang === 'english') { return 'Mid Floor'; }
        return '中層';
      }
      if (f === '**LOW**') {
        if (lang === 'english') { return 'Low Floor'; }
        return '低層';
      }
      return '';
    },
    floorFormat(f) {
      if (f === '**HIGH**') {
        return this.$t('transaction.HIGH_FLOOR');
      }
      if (f === '**MID**') {
        return this.$t('transaction.MID_FLOOR');
      }
      if (f === '**LOW**') {
        return this.$t('transaction.LOW_FLOOR');
      }
      return '';
    },
    flatFormat(tx) {
      let flat = '';
      if (tx.flat === 'WF') {
        flat = this.$t('transaction.WF');
      } else {
        flat = tx.flat ? `${tx.flat} ${this.$t('transaction.FLAT')}` : '';
      }

      if (this.ics === 's') {
        if (tx.streetno) {
          if (window.lang === 'english') {
            flat = `${tx.streetno}`;
          } else {
            flat = `${tx.streetno}號`;
          }
        }
      }

      return flat;
    },
    numberFormat(value) {
      const num = value;
      let re = '';

      if (window.lang === 'english') {
        const ob = ((num / 1000000000) - ((num / 1000000000) % 1));
        if (ob > 0) { re += `${this.fmt(ob, 0, 3, ',')}B`; }

        const om = (num - (ob * 1000000000)) / 1000000;
        if (om > 0) { re += `${this.fmt(om, 2, 3, ',')}M`; }

        if (re === '') {
          return this.fmt(num, 0, 3, ',');
        }
      } else {
        const hm = parseInt(num / 1e8, 10);
        if (hm > 0) { re += `${this.fmt(hm, 0, 3, ',')}億`; }

        const tk = Math.round((num % 1e8) / 10000);
        if (tk > 0) { re += `${this.fmt(tk, 0, 3, ',')}萬`; }

        if (re === '') {
          return this.fmt(num, 0, 3, ',');
        }
      }
      return re;
    },
    formatTx(transactions) {
      return transactions.map((tx) => {
        const name = {};
        const floor = {};
        const flat = {};
        const area = {};
        const icsType = this.ics;
        const keyword = {};

        name.zh = tx.name_zh;
        name.en = tx.name_en ? tx.name_en : tx.name_zh;
        area.value = parseInt(tx.area, 10);

        if (icsType === 's') {
          floor.zh = tx.floor_zh ? tx.floor_zh : '';
          floor.en = tx.floor_en ? tx.floor_en : '';

          flat.zh = tx.flat;
          flat.en = tx.flat;

          name.zh = `${tx.district.name_zh} ${name.zh} ${tx.streetno} ${tx.streetno ? '號' : ''} ${floor.zh} ${flat.zh}`;
          name.en = `${flat.en}${flat.en ? ', ' : ''} 
                    ${floor.en}${floor.en ? ', ' : ''} 
                    ${tx.streetno} ${name.en}${tx.district.name_en ? ', ' : ''} ${tx.district.name_en}`;

          area.zh = [];
          area.en = [];

          for (let i = 1; i <= 4; i += 1) {
            if (parseInt(tx[`area${i}`], 10) > 0 && tx[`area_desc${i}`]) {
              const ad = tx[`area_desc${i}`];
              const av = parseInt(tx[`area${i}`], 10);
              const ao = {
                desc: ad,
                value: av,
              };
              area.zh.push(ao);
              area.en.push(ao);
            }
          }

          keyword.searchText = `{"suggestionWord":"${tx.name_zh}","type":"addr","value":"${tx.street_id}","ics":"${icsType}"}`;
        } else {
          floor.zh = tx.floor_zh ? tx.floor_zh : '';
          floor.en = tx.floor_en ? tx.floor_en : '';

          if (tx.flat === 'WF') {
            flat.zh = '全層';
            flat.en = 'Whole Floor';
          } else {
            flat.zh = `${tx.flat}${tx.flat ? '室' : ''}`;
            flat.en = `${tx.flat ? 'Unit ' : ''} ${tx.flat}`;
          }

          name.zh = `${tx.district.name_zh} ${name.zh} ${floor.zh} ${flat.zh}`;
          name.en = `${tx.district.name_en} ${name.en} ${floor.en} ${flat.en}`;

          keyword.searchText = `{"suggestionWord":"${tx.name_zh}","type":"building","value":"${tx.pis_bldg_id}","ics":"${icsType}"}`;
        }

        return {
          ...tx,
          icsType,
          name,
          floor,
          flat,
          area,
          keyword,
        };
      });
    },
  },
  apollo: {
    txC: {
      client: 'api',
      query: gql`
          query ($pisBuildingId: String!, $txType: String) {
            txC: transactionRaw(company: MR, ics: COMM, pisBuildingId: $pisBuildingId, tx_type: $txType) {
              tx_date
              name_zh
              name_en
              district {
                name_zh
                name_en
              }
              floor
              flat
              areas {
                amount
              }
              tx_type
              sell_feet
              sell_total
              rent_feet
              rent_total
              upload_source
            }
          }
        `,
      variables() {
        return {
          pisBuildingId: this.pisBuildingId,
          txType: this.txType ? this.txType : 'S',
        };
      },
      skip() {
        return !this.pisBuildingId;
      },
    },
    txI: {
      client: 'api',
      query: gql`
          query ($pisBuildingId: String!, $txType: String) {
            txI: transactionRaw(company: MR, ics: IND, pisBuildingId: $pisBuildingId, tx_type: $txType) {
              tx_date
              name_zh
              name_en
              district {
                name_zh
                name_en
              }
              floor
              flat
              areas {
                amount
              }
              tx_type
              sell_feet
              sell_total
              rent_feet
              rent_total
              upload_source
            }
          }
        `,
      variables() {
        return {
          pisBuildingId: this.pisBuildingId,
          txType: this.txType ? this.txType : 'S',
        };
      },
      skip() {
        return !this.pisBuildingId;
      },
    },
    txS: {
      client: 'api',
      query: gql`
          query ($pisBuildingId: String!, $txType: String) {
            txS: transactionRaw(company: MR, ics: SHOP, pisBuildingId: $pisBuildingId, tx_type: $txType) {
              tx_date
              name_zh
              name_en
              district {
                name_zh
                name_en
              }
              street_name_zh
              floor
              flat
              streetno
              areas {
                amount
                name_zh
                name_en
              }
              tx_type
              sell_feet
              sell_total
              rent_feet
              rent_total
              upload_source
            }
          }
        `,
      variables() {
        return {
          pisBuildingId: this.pisBuildingId,
          txType: this.txType ? this.txType : 'S',
        };
      },
      skip() {
        return !this.pisBuildingId;
      },
    },
  },
};
</script>
<style scoped>
  .ov-scroll {
    overflow: auto;
  }
  .tx-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 600px;
  }
  .tx-table tr {
    border-bottom: 1px solid #ccc;
  }
  .tx-table td, .tx-table th {
    padding: 8px 5px;
  }

  .tx-type {
    padding: 3px;
    background-color: #eee;
  }
  .building-name {
    font-size: 20px;
  }
  .area-value, .price-feet-value, .price-total-value { 
    font-size: 23px;
  }
  
  .transaction-list {
    width: 100%;
  }
  
  .transaction-list th {
    padding: 8px 5px;
    background: #E7EEF9;
  }
  
  .transaction-list th:first-child {
    padding: 8px 5px 8px 15px;
  }
  
  .transaction-list th:last-child {
    padding: 8px 15px 8px 5px;
  }
  
  .transaction-list tbody tr:nth-child,
  .transaction-list > div:nth-child {
    background-color: #FFFFFF;
  }
  
  .tx-card-container {
    padding: 0px;
  }
  
  .tx-record-card:nth-child, .news-container:nth-child {
    background: #FFFFFF;
  }
  
  .more-btn {
    margin: 20px 0 0 0;
  }

  .no-tx {
    padding: 30px 0;
    text-align: center;
    font-size: 20px;
  }
</style>